"use client";

import { cn } from "@/lib/tailwind";
import NextImage, { type ImageProps } from "next/image";
import React from "react";

const Image = (props: ImageProps) => {
  const clRegex = new RegExp("^https?:\\\\(mcdn\.(magrabi|doctorm)\.com|res\.cloudinary\.com)");
  const isCldImage = typeof props.src === "string" && clRegex.test(props.src);
  const { src, onLoad, loader, className, ...rest } = props;
  return isCldImage ? (
    <img
      src={props.src as string}
      className={cn("opacity-0 transition-opacity duration-200", className)}
      {...rest}
      onLoad={(e) => e.currentTarget.classList.remove("opacity-0")}
    />
  ) : (
    <NextImage
      src={src}
      className={cn("opacity-0 transition-opacity duration-200", className)}
      onLoad={(e) => e.currentTarget.classList.remove("opacity-0")}
      {...rest}
    />
  );
};

export default Image;
export { ImageProps };
